.alert.cookie-message {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: $zindex-fixed;
	background-color: #F6F4EF;
	padding-block: 20px;
	box-shadow: 0px 4px 18px 0px rgba(0, 0, 0, 0.2509803922);

	.container {
		padding-right: .75rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 16px;

		@include media-breakpoint-down(md) {
			flex-direction: column;
			align-items: flex-start;
		}

		p {
			margin: 0;
		}
		.cookie-links {
			flex: 0 0 auto;
		}
	}

	.arrow-link__underline--animate {
		color: $primary;
		border-color: $primary;

		span {
			color: $primary;

			.svg-icon * {
				color: $primary;
				fill: $primary !important;
			}
		}
	}
}

.app-cookie {
	background-color: #FFF;
	box-shadow: 0px -4px 14px rgba(0, 37, 64, 0.10);

	> .container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		justify-content: center;

		img{
			max-width: 115px;
			margin: 0 10px;
		}

		> * {
			padding: 0 $gutter-def;
			flex: 1 0 auto;
			font-size: 16;

			&:nth-child(2) {
				padding-left: 0;
				max-width: 75%;
			}

			&:last-child {
				padding-right: 0;
				text-align: center;
			}
		}
	}

	p {
		margin: 0;
		padding: 0;
		color: #092B27;
	}

	.cookie-links {
		@include row-cols(1);
		max-width: 250px;

		[class^="arrow-link"] {
			padding: 0;
			width: auto;

			.svg-icon {
				border-bottom: solid 1px $primary;
				margin: 0 0 0 5px;
				bottom: -1px;

				svg {
					margin: 0 0 1px;
				}
			}
		}

		> :first-child {
			margin: 0 0 10px;
		}
	}
}

@include media-breakpoint-down(md) {
	.alert.cookie-message {
		.container {
			padding: 0 35px;

			> * {
				padding: 0;
			}

			p {
				max-width: 100%;
				@include text-size(12);
			}

			img {
				display: none;
			}
		}
	}

	.app-cookie {
		> .container {
			flex-direction: column;
			padding: 0 35px;
		}

		.cookie-links {
			padding: 0;
			margin: 15px 0 0;

			> :first-child { 
				margin-bottom: 0;
			}
		}
	}
}